import { FC } from 'react';
import { useRoutes } from 'react-router-dom';
import { path } from '../../paths';
import { onBasePath } from '../../paths/onBasePath';
import { SystemClassifierDirectory } from './SystemClassifierDirectory';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './SystemClassifiers.translations.json';
import { NotFound } from '../NotFound';
import { SystemClassifierBreadcrumbsData } from './SystemClassifierBreadcrumbs';
import { SystemClassifierDetails } from './SystemClassifierDetails';
import { SystemClassifierEdit } from './SystemClassifierEdit';

export const { addTranslations, useTranslation, Translation } =
  i18nNsFactory('classifiers-page');
addTranslations(translations);

export const SYSTEM_CLASSIFIER_ROUTES = [
  {
    path: path.systemClassifierDirectory,
    renderBreadcrumb: () => (
      <Translation>{(t) => t('breadcrumb.system-classifiers')}</Translation>
    ),
    children: [
      {
        index: true,
        element: <SystemClassifierDirectory />,
      },
      {
        path: path.systemClassifierDetails,
        element: <SystemClassifierDetails />,
        renderBreadcrumb: (data?: SystemClassifierBreadcrumbsData) =>
          data ? (
            `${data.code} - ${data.name}`
          ) : (
            <Translation>
              {(t) => t('breadcrumb.system-classifier-detail')}
            </Translation>
          ),
      },
      {
        path: path.systemClassifierEdit,
        renderBreadcrumb: () => (
          <Translation>
            {(t) => t('breadcrumb.system-classifier-edit')}
          </Translation>
        ),
        element: <SystemClassifierEdit />,
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export const SystemClassifiers: FC<{ basePath: string }> = ({ basePath }) =>
  useRoutes(onBasePath(basePath, SYSTEM_CLASSIFIER_ROUTES));
